import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class Tag extends Vue {
  @Prop({ type: String, required: false })
  label!: string;

  @Prop({ type: String, default: '#F0F1F8' })
  color!: string;

  @Prop({ type: String, default: '#262729' })
  textColor!: string;

  @Prop({ type: Boolean, default: false })
  clickable!: boolean;

  @Prop({ type: Boolean, default: false })
  selected!: boolean;

  isSelected: boolean = this.selected;

  get inputListeners(): any {
    const cthis = this;

    return Object.assign({}, this.$listeners, {
      click: (e: any) => cthis.onClick(e)
    });
  }

  onClick(e: any): void {
    if (this.clickable) {
      this.isSelected = !this.isSelected;
    }

    this.$emit('click', e);
  }
}
